export const allowedSubAccountStates = [
  'AWAITING_APPROVAL',
  'ACTIVE',
];
